import { Text } from '@chakra-ui/react'

import { InternalLink } from 'components/Links'

import { Card } from 'containers/Card'

export default function NotFound() {
  return (
    <Card>
      <Text>There's nothing here!</Text>
      <br />
      <Text>
        Go to <InternalLink color='teal.500' name='Login' href='/login' /> or{' '}
        <InternalLink
          color='teal.500'
          name='Public Organizations'
          href='/public/orgs'
        />
      </Text>
    </Card>
  )
}
